import moment from 'moment'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import uuid from 'uuid/v4'

import { CircularProgress, Grid, IconButton, Paper } from '@material-ui/core'
import { FaCloudDownloadAlt, FaCloudUploadAlt } from 'react-icons/fa'
import Context from '../../../../context'
import { createClientValidations } from '../../../../services/ClubeApi'
import DeleteDialog from '../../../CommentsManagerPage/Components/DeleteDialog'
import useStyles from './styles'

function CommentsItem({ data, showActions }) {
  const classes = useStyles()
  const [openDialog, setOpenDialog] = useState(false)
  const [commentToDelete, setCommentToDelete] = useState('')
  const [commentData, setCommentData] = useState(data)
  const [isLoading, setIsLoading] = useState(false)

  const changeSituation = status => {
    console.log('status', status)
    setIsLoading(true)
    const body = { id: commentData.id, status }

    createClientValidations(body).then(r => {
      console.log('update R', r)
      if (r) {
        setIsLoading(false)
        setCommentData({ ...commentData, status })
      }
    })
  }

  const handleDeleteItem = () => {
    setCommentToDelete(commentData.comment)
    setOpenDialog(true)
  }

  return (
    <Grid key={uuid()} container spacing={3}>
      <Grid item xs={1} className={classes.dividerArea}>
        <div className={classes.divider}>
          <div className={classes.dividerCircle} />
        </div>
      </Grid>
      <Grid item xs={11}>
        <Paper className={classes.commentPaperArea}>
          <Grid container>
            <Grid item xs={2} className={classes.commentDateArea}>
              <div className={classes.commentDay}>
                {moment(commentData.date).format('DD/MMM').toString()}
              </div>
              <div className={classes.commentHour}>
                {moment(commentData.date).format('HH:MM').toString()}
              </div>
            </Grid>
            <Grid item xs={7} className={classes.commentTextArea}>
              {commentData.comment}
            </Grid>
            {showActions && (
              <Grid item xs={2} className={classes.buttonArea}>
                {isLoading ? (
                  <Grid className={classes.progressArea}>
                    <CircularProgress />
                  </Grid>
                ) : (
                  <>
                    {commentData.status === 3 && (
                      <IconButton
                        className={classes.publishIcon}
                        onClick={() => {
                          changeSituation(2)
                        }}
                      >
                        <FaCloudUploadAlt />
                      </IconButton>
                    )}
                    {commentData.status === 2 && (
                      <IconButton className={classes.trashIcon} onClick={handleDeleteItem}>
                        <FaCloudDownloadAlt />
                      </IconButton>
                    )}
                  </>
                )}
              </Grid>
            )}
          </Grid>
        </Paper>
      </Grid>
      <Context.Provider value={{ openDialog, setOpenDialog, commentToDelete }}>
        <DeleteDialog changeSituation={changeSituation} />
      </Context.Provider>
    </Grid>
  )
}

CommentsItem.defaultProps = {
  showActions: false
}

CommentsItem.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    date: PropTypes.string,
    comment: PropTypes.string,
    situation: PropTypes.number
  }).isRequired,
  showActions: PropTypes.bool
}

export default CommentsItem
